module.exports = __webpack_public_path__ + "2ae43cdb8bf22e235d4f080fc076a223.png";